import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../components/AsyncComponent';

const AuthenticationSetting = asyncComponent(() =>
  import('../../../containers/authorised/setting/authentication/AuthenticationSetting')
)

const authenticationRoutes = (
  <Switch>
    <Route exact path="/settings/authentication" component={AuthenticationSetting} />
  </Switch>
);

export default authenticationRoutes;